export function splitErrorMessage(message: string): string[] {
  if (!message) {
    return [];
  }

  return message
    .split('\n')
    .map(line => line.replace(/^•\s*/, '').trim())
    .filter(line => line.length > 0);
}
